import GuideRow from "../../../GuideRow";
import GuideOvpnData from "../../GuideOvpnData";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

const LinuxGuide = ({ subscription, servers = [] }) => {
  const navigate = useNavigate();
  const { t, _ } = useTranslation();
  if (!subscription) {
    return;
  }

  return (
    <>
      <GuideRow
        number="1"
        text={t("Start terminal and install OpenVPN client")}
        code="sudo apt install openvpn"
      />
      <GuideRow
        number="2"
        text={t("Download the configuration file")}
        actionPaddingLeft="none"
        action={<GuideOvpnData subscription={subscription} servers={servers} />}
      />
      <GuideRow
        number="3"
        text={t("Start OpenVPN client with downloaded configuration file")}
        code="sudo openvpn --config /path/to/your/config.ovpn"
      />
      <GuideRow
        number="4"
        text={t(
          "If you are unable to connect, try configuring using a different instruction or contact support"
        )}
        action={
          <div
            className="link"
            onClick={() =>
              navigate("/account/guide/all", {
                state: { subscription: subscription },
              })
            }
          >
            {t("Check other guides")}
          </div>
        }
      />
    </>
  );
};

export default LinuxGuide;
